import React, { useRef, useEffect, useState, useContext } from 'react';
import './Modal.css';
import OcrTemplates from '../History/STS/QuickLinks';
import { HighlightComments } from '../History/STS/HighlightComments';
import { ticketViewService } from '../../services/merpservices';
import EmployeeContext from '../../utils/EmpDetails/EmployeeProvider';
import { gaEvent } from '../../utils/GoogleAnalytics/gatracking';
import { safeHtml } from '../../utils/sanitizeHtml';

const ModalNew = ({ glid, dispId, custId, show, header, history = null, onClose, screen = null, ticketStatus = null, ticketId = null, isDispSet = null, ticketType = null, issueDate = null, tktGroupId = null,isticketbystsowner =null}) => {
    const textareaRef = useRef(null);
    const employeeDetails = useContext(EmployeeContext);
    const [ticketHistory, setTicketHistory] = useState("");
    const [ticketIdCount, setTicketIdCount] = useState("");

    const autoResize = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";  // Reset the height to auto
            textarea.style.height = `${textarea.scrollHeight}px`;  // Adjust height based on scrollHeight
        }
    };

    useEffect(() => {
        autoResize();
    }, [history, ticketHistory, show])
    
    const tktIdDetails = async () => {
        const condition = `&ticketid=${ticketId}`;
        if(show){
            try {
                const res = await ticketViewService(employeeDetails.empid, employeeDetails.ak, glid, condition);
                if (res?.data?.status === 200) {
                    const tktIdHistory = res.data.data.ticketDetail[0];
    
                    setTicketHistory(tktIdHistory?.TICKET_HISTORY);
                    setTicketIdCount(tktIdHistory?.MAIL_SENT_COUNTER || "0" );
                } else {
                    setTicketHistory("");
                    setTicketIdCount("");
                }
            } catch (error) {
                console.log(error);
            }
            gaEvent("Ticket Radio Button", "Ticket ID for ticket history", "click", "Ticket ID for ticket history", glid);
        }
    }

    useEffect(() => {
        tktIdDetails();
    }, [ticketId])

    if (!show) {
        return null;
    }

    return (
        <div className="modal" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {
                    header && 
                    <div className='modal-header'>{header}</div>
                }
                <div className="modal-body">
                    {
                        (screen === 'sts-popup' || screen === 'ticket-popup')
                        ?   <table>
                                <tr>
                                    <td style={(ticketStatus === 'WIP') ? {maxWidth: '65vw'} : {maxWidth: '100vw'}}>
                                        {
                                            (screen === 'sts-popup') 
                                            ? <div className='modal-sts-history' dangerouslySetInnerHTML={safeHtml(HighlightComments(history))}></div>
                                            : <div className='modal-sts-history'>
                                                <textarea className='ticket-textarea' ref={textareaRef} cols={115} readOnly value={ticketHistory}></textarea>
                                            </div>
                                        }
                                    </td>
                                    {
                                        (ticketStatus === 'WIP')
                                        ? <td style={{alignItems: 'flex-start', display: 'flex'}}>
                                            <OcrTemplates glid={glid} dispId={dispId} descId={dispId} custId={custId} screen={screen} isDispSet={isDispSet} ticketId={ticketId} ticketCount={ticketIdCount} ticketType={ticketType} history={tktIdDetails} issueDate={issueDate} tktGroupId={tktGroupId} isticketbystsowner={isticketbystsowner}/>
                                          </td>
                                        : <></>
                                    }
                                </tr>
                            </table>
                        :
                           ( screen === 'es-popup') ?  <div className='modal-history fw-400' style={{width:'550px', height:'auto'}}  dangerouslySetInnerHTML={safeHtml(history)} readOnly></div> : <textarea className='modal-history fw-400' cols="50" rows="10" value={history} readOnly></textarea>
                        
                    }
                </div>
            </div>
        </div>
    );
};

export default ModalNew;
